export const AD_SLOTS = {
  contentGeneric: "6005765715",
  resultsLatestUpdate: "6690668134",
  resultsHub: "5959906949",
  resultsSsc: "4646825278",
  guides: "9082961989",
  afterIntermediate: "7516664647",
  pageTop: "8631929056",
  pageBottom: "3651065117",
};
